import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Injectable()
export class AuthGuard  {

    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (await this.oktaAuth.isAuthenticated()) {
            return true;
        }
        // Remember where the user was heading and start the PKCE login; the callback restores it.
        this.oktaAuth.setOriginalUri(state.url);
        await this.oktaAuth.signInWithRedirect();
        return false;
    }
}
